<template>
  <div class="Message-container" ref="messageContainer" v-loading='loading'>
    <MessageArea title="留言板" :list='list' :subTitle="`(${datas.total||total})`" @handleSubmit="handleSubmit"/>
    <div class="loading" v-loading="vloading"></div>
  </div>
</template>

<script>
import fetchData from '@/mixins/fetchData'
import scrollTop from '@/mixins/scrollTop'
import { getMessage, submitMessage } from '@/api/message'
import MessageArea from '@/components/MessageArea'
import {SERVER_URL} from '@/util/urlConfig'

export default {
  name: "Message",
  mixins: [fetchData({}),scrollTop('messageContainer')],
  components: { MessageArea },
  data(){
    return {
      total: 0,
      page: 1,
      limit: 10,
      vloading:false
    }
  },
  mounted(){
    this.$bus.$on('mainScroll',this.handleScroll)
  },
  computed:{
    list(){
      return this.datas.rows.map(e=>({...e,avatar: SERVER_URL+e.avatar}))
    }
  },
  methods: {
    handleScroll(dom){
      if(!dom) return
      // 设置一个触发底部的阈值
      const flag = 100
      // 计算差值
      const dec = Math.abs(dom.scrollHeight-(dom.scrollTop + dom.clientHeight))
      if(dec<=flag) {
        this.loadMore()
      }
    },
    async handleSubmit(formData,callback){
      const data = {
        ...formData
      }
      const result = await submitMessage(data)
      this.datas.total++
      this.datas.rows.unshift(result)
      callback('感谢您的留言！')
    },
    // 加载更多
    async loadMore(){
      if(this.vloading) return
       if(this.datas.rows.length>=this.datas.total) return
      this.page++
      this.vloading = true
      const res = await this.fetchData()
      this.vloading = false
      this.datas.rows = [...this.datas.rows,...res.rows]
    },
    fetchData(){
      const params = {
        total: this.total,
        page: this.page,
        limit: this.limit
      }
      return getMessage(params)
    }
  }
};
</script>

<style lang="less">
.Message-container{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
  padding: 60px 100px;
}
.loading{
  height: 100px;
  position: relative;
}
</style>
